<script lang="ts">
	import { logger } from '@tickrr/lib/logger';
	import _ from 'lodash';
	import { onMount } from 'svelte';

	let scrollEl: HTMLElement | null = null;
	let scrollProgressPct: number = 0;

	const trackScrollProgress = _.throttle(() => {
		const scrollTop = scrollEl?.scrollTop;
		const scrollHeight = scrollEl?.scrollHeight;
		const clientHeight = scrollEl?.clientHeight;

		if (!scrollTop || !scrollHeight || !clientHeight) {
			logger.warn(
				'Scroll progress tracker could not find scrollTop, scrollHeight, or clientHeight. Unable to calculate scroll progress.'
			);
			return;
		}

		const newScrollProgressPct = Math.min(scrollTop / (scrollHeight - clientHeight), 1);

		// When at the top, this value will not always zero out, so we round small values to zero.
		// This ensures the scroll progress bar is hidden when user is at the top of the page.
		if (newScrollProgressPct < 0.05) {
			scrollProgressPct = 0;
			return;
		}

		scrollProgressPct = newScrollProgressPct;
	}, 25);

	onMount(() => {
		scrollEl = document.getElementById('page');

		if (!scrollEl) {
			logger.warn('Scroll progress tracker could not find the page element.');
			return;
		}

		scrollEl.addEventListener('scroll', trackScrollProgress);
	});
</script>

<div
	class="sticky top-0 z-[9999] h-2 bg-primary-500"
	style="width: {scrollProgressPct * 100}%"
></div>
